jQuery(document).ready(function ($) {
  $("a[data-video-trigger]").on("click", function (e) {
    e.preventDefault();
    var videoClass = $(this).data("video-trigger");

    // Hide all video divs
    $("#video-showcase-player .vs-video").hide();

    // Show the triggered video div
    $("#video-showcase-player ." + videoClass).show();
  });
});
